import React from "react";
import useReportFeedback from "../../hooks/useReportFeedback";
import { ScrollSentinel, FeedbackSegment } from "./segments";

const ReportWrapper = ({
  funnelStep,
  assessmentId,
  assessmentAttemptId,
  currentLocale,
  SubmitSurveyFeedbackConnect,
}) => {
  const { userGUID, isAuth } = funnelStep || {};

  const {
    showFeedbackPopup,
    showTrustpilotModal,
    feedbackSentinelRef,
    handleSurveyFeedback,
    handleFeedbackClose,
    handleFeedbackProceed,
    handleTrustpilotClose,
  } = useReportFeedback({
    userGUID,
    assessmentId,
    assessmentAttemptId,
    currentLocale,
    isAuth,
    SubmitSurveyFeedbackConnect,
  });

  return (
    <>
      {/* ScrollSentinel is being used in component.js to detect when the user
      scrolls to the bottom of the page. It's the sentinel element that the
      IntersectionObserver watches. */}
      <ScrollSentinel ref={feedbackSentinelRef} />
      <FeedbackSegment
        showFeedbackPopup={showFeedbackPopup}
        showTrustpilotModal={showTrustpilotModal}
        handleFeedbackClose={handleFeedbackClose}
        handleFeedbackProceed={handleFeedbackProceed}
        handleSurveyFeedback={handleSurveyFeedback}
        handleTrustpilotClose={handleTrustpilotClose}
      />
    </>
  );
};

export default ReportWrapper;
